export default __webpack_public_path__ + "static/media/xero.b0d4232d.svg";